export default function timeAgo(targetTimestamp) {
    // Parse the target timestamp
    const targetTime = new Date(targetTimestamp);

    // Current time
    const currentTime = new Date();

    // Calculate the difference in milliseconds
    const differenceMs = currentTime - targetTime;

    // Convert to minutes, hours, and days
    const seconds = Math.floor(differenceMs / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    // Determine the output format
    let result;
    if (days > 0) {
        result = `${days} day${days > 1 ? 's' : ''} ${hours % 24} hr${hours % 24 > 1 ? 's' : ''}`;
    } else if (hours > 0) {
        result = `${hours} hr${hours > 1 ? 's' : ''} ${minutes % 60} min${minutes % 60 > 1 ? 's' : ''}`;
    } else if (minutes > 0) {
        result = `${minutes} min${minutes > 1 ? 's' : ''}`;
    } else {
        result = `${seconds} sec${seconds > 1 ? 's' : ''}`;
    }

    return result;
}